import { Radio } from 'antd'
import { RadioProps } from 'antd/lib'
import styled from 'styled-components'
import { Text } from '../../general'

interface FormRadioProps extends RadioProps {
  text: string
  subText?: string
}

const FormRadio = ({ text, subText, ...rest }: FormRadioProps) => (
  <StyledRadio {...rest}>
    <ProfileRadioLabelContainer>
      <ProfileRadioLabelText>{text}</ProfileRadioLabelText>
      {subText && (
        <ProfileRadioLabelSubText level={2}>{subText}</ProfileRadioLabelSubText>
      )}
    </ProfileRadioLabelContainer>
  </StyledRadio>
)

export default FormRadio

const StyledRadio = styled(Radio)`
  border: none;
  padding: 4px 0 0;
  background-color: transparent !important;
  // hate to use this but this is affected by an !important elsewhere, we need to stop doing this
`

const ProfileRadioLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
`

const ProfileRadioLabelSubText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const ProfileRadioLabelText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
`
